export default "__VITE_ASSET__C0jP5TTt__"